export default class TicketGuard {

    $ticketService;

    constructor(ticketService) {
        this.$ticketService = ticketService;
    }

    check(to, from, next) {
        this.$ticketService.ticketValid()
            .then(
                () => next()
            )
            .catch(
                () => next({
                    name: 'home'
                })
            )

    }
}
